import { IExpense, IGroupedApprovalExpense } from "./expenseModule.types";

export const execGroupDataByUserAndProjectName = (
  data: IExpense[],
): IGroupedApprovalExpense[] => {
  const groupedData = Object.values(
    data.reduce(
      (acc, obj) => {
        const userName = obj.user_name ?? "UNKNOWN_USER"; // fallback if null
        const projectName = obj.project_name;
        const key = `${obj.user_uuid}|${obj.project_uuid}`;

        if (!acc[key]) {
          acc[key] = {
            ...obj,
            user_name: userName,
            project_name: projectName,
            expense_type: obj.expense_type,
            payment_type: obj.payment_type,
            childs: [obj],
          };
        } else {
          acc[key].childs.push(obj);
        }

        return acc;
      },
      {} as Record<string, IGroupedApprovalExpense>,
    ),
  );

  return groupedData;
};
